// extracted by extract-css-chunks-webpack-plugin
module.exports = {"tree":"tree_VKguK"};